import React from 'react';
import { Box, Container, Grid, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ShieldIcon from '@mui/icons-material/Shield';
import VestingTimeline from './components/VestingTimeline/VestingTimeline';
import PresaleCard from './components/Presale/PresaleCard';
import TierTable from './components/TierTable/TierTable';
import BuybackStats from './components/BuybackStats/BuybackStats';

const SalesPage = () => {
    const theme  = useTheme();
    const isDark = theme.palette.mode === 'dark';


    const featureBg     = isDark ? 'rgba(255,255,255,0.03)' : 'rgba(10,16,32,0.03)';
    const featureBorder = isDark ? '1px solid rgba(255,255,255,0.06)' : `1px solid ${theme.palette.divider}`;

    return (
        <Box sx={{
            minHeight: '100vh',
            pt: { xs: 12, md: 16 },
            pb: 12,
            bgcolor: 'background.default',
            backgroundImage: isDark
                ? 'radial-gradient(circle at 15% 15%, rgba(210,157,92,0.08), transparent 25%), radial-gradient(circle at 85% 85%, rgba(100,116,139,0.08), transparent 25%)'
                : 'none',
        }}>
            <Container maxWidth="xl">
                <Grid container spacing={8}>

                    {/* LEFT COLUMN */}
                    <Grid item xs={12} md={7}>
                        <Box sx={{ mb: 5 }}>
                            <Typography variant="h2" fontWeight={800} gutterBottom sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' }, lineHeight: 1.1, color: 'text.primary' }}>
                                Systematic <br />
                                <span style={{ color: theme.palette.primary.main }}>Architecture</span>
                            </Typography>
                            <Typography variant="h6" color="text.secondary" paragraph sx={{ maxWidth: 600, lineHeight: 1.8 }}>
                                Active Systematic Strategies deployed in multi assets (BTC, ETH &amp; LINK) to generate revenue from volatility, supporting the $0.90 buyback target and buybacks for reward distributions.
                            </Typography>
                        </Box>

                        {/* Tier table — sits right under the description */}
                        <Box sx={{ mb: 6 }}>
                            <TierTable />
                        </Box>

                        {/* <Grid container spacing={4} sx={{ mb: 6 }}>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ p: 3, bgcolor: featureBg, borderRadius: 2, border: featureBorder, height: '100%' }}>
                                    <SmartToyIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                                    <Typography variant="h6" fontWeight={700} color="text.primary" gutterBottom>Automated Execution</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                                        Capital is deployed into high-efficiency systematic strategies.
                                        <br /><br />
                                        • <strong>40% BTC Strategy</strong> (Conservative)<br />
                                        • <strong>60% LINK Strategy</strong> (Adaptive)
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ p: 3, bgcolor: featureBg, borderRadius: 2, border: featureBorder, height: '100%' }}>
                                    <ShieldIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                                    <Typography variant="h6" fontWeight={700} color="text.primary" gutterBottom>Volatility Harvesting</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                                        Capturing volatility-driven alpha via rules-based on-chain systems.
                                        <br /><br />
                                        • <strong>Active Deployment</strong><br />
                                        • <strong>Systematic Buybacks</strong>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid> */}

                        <Box sx={{ mt: 8 }}>
                            <BuybackStats />
                        </Box>
                    </Grid>

                    {/* RIGHT COLUMN */}
                    <Grid item xs={12} md={5}>
                        <Stack spacing={4}>
                            <PresaleCard />
                        </Stack>
                    </Grid>

                </Grid>
            </Container>

        </Box>
    );
};

export default SalesPage;
